module.exports = __webpack_public_path__ + "static/img/spray_2.fa176ca5.png";